export default __webpack_public_path__ + "static/media/duckoys.7190f45c.jpg";